<ng-container *ngIf="!useRefreshedSolutionParticipationUI">
<div class="chart-title">
  <div *ngIf="chartTitle" id="chart-text-{{widgetType}}" class="chart-text">{{chartTitle}}</div>
</div>

<div class="gauge-chart-container">
  <div class="loader-container" *ngIf="displayWidgetLoader">
    <loader [size]="'medium'"></loader>
  </div>

  <ng-container *ngIf="(multipleContractsSelected && widgetType === 'all' && !displayWidgetLoader && !showMessageBlock) ||
  (!multipleContractsSelected && !displayWidgetLoader && !showMessageBlock)">
    <app-widget-gauge-chart
      [widgetType]="widgetType"
      [data]="widgetChartData"
      [colors]="widgetChartColors"
      [showNeedle]="isRebateChart">
    </app-widget-gauge-chart>

    <div id="location-gauge-legend" class="location-gauge-legend">
      <!-- Legend block -->
      <div class="legend-items" *ngIf="isRebateChart">
        <div class="chart-legend qualifying" id="{{widgetType}}-qualifying-legend">Qualifying</div>
        <div class="chart-legend not-qualifying" id="{{widgetType}}-not-qualifying-legend">Not Qualifying</div>
      </div>
      <!-- Tooltip information Icon Block -->
      <div class="info-icon" (mouseenter)="trackTooltipMixpanelEvent()">
        <img src="assets/information-icon.svg" alt="Information icon" />
        <span class="tooltip" [innerHTML]="tooltipContent">
          Information about qualifying and non-qualifying statuses.
        </span>
      </div>
    </div>
  </ng-container>

  <!-- Message Section -->
  <ng-container *ngIf="!displayWidgetLoader && showMessageBlock">
    <div *ngIf="multipleContractsSelected && widgetType !== 'all'" class="message-block">
      <p>{{ multipleHierarchiesSelectedMessage}}</p>
    </div>

    <div *ngIf="noSalesData" class="message-block">
      <p>No Sales Data</p>
    </div>

    <div *ngIf="noRebatesNorProductLists" class="message-block">
      <p>No Rebate or Products Lists entered</p>
    </div>

    <div *ngIf="noProductList" class="message-block">
      <p>No Product Lists entered</p>
    </div>

    <div *ngIf="!eligibleForRebate" class="message-block">
      <p>No Agreements</p>
    </div>

    <div *ngIf="!multipleContractsSelected && multipleRebatesExistForContract && widgetType === 'rebate'" class="message-block">
      <p>Rebate information is not shown because multiple rebates are associated with this item. Please contact the Finance team for details.</p>
    </div>
  </ng-container>
</div>
</ng-container>

@if (useRefreshedSolutionParticipationUI) {
<ng-container id="sp-bar-graph-section" class="py-6">
  <!-- Skeleton shown while the overview progress bar data is loading -->
  @if (displayWidgetLoader) {
  <div class="flex items-center gap-4 animate-pulse" id="sp-overview-bar-skeleton">
    <div class="flex-1 h-[19px] rounded-full bg-neptune-subtle"></div>
    <div class="size-4 rounded-full bg-neptune-subtle shrink-0"></div>
  </div>
  }

  @if ((multipleContractsSelected && widgetType === 'all' && !displayWidgetLoader && !showMessageBlock) ||
  (!multipleContractsSelected && !displayWidgetLoader && !showMessageBlock)) {
  <section>
    <!-- Neptune Overview Progress Bar bar + target marker + proportional labels, plus the same info tooltip legacy shows -->
    <div class="flex items-center gap-4">
      <app-widget-bar-graph
        class="flex-1"
        [widgetType]="overviewBarGraphType"
        [value]="widgetChartData[0]"
        [total]="widgetChartData[1]"
        [targetValue]="rebateComplianceTarget"
        [ariaLabel]="chartTitle">
      </app-widget-bar-graph>

      <!-- Tooltip information icon, reusing the existing tooltipContent/mixpanel tracking -->
      <div class="widget-tooltip-{{widgetType}} relative group shrink-0" (mouseenter)="trackTooltipMixpanelEvent()">
        <img src="assets/shared-icons/neptune-icon-black-info.svg" alt="Information icon" class="size-4 cursor-pointer" />
        <span class="hidden group-hover:block absolute right-0 top-full mt-1 z-20 w-64 rounded-md bg-neptune-subtle border border-solid border-neptune-border-subtle shadow-neptune-elevation-2 p-3 text-xs text-neptune-neutral"
        [innerHTML]="neptuneTooltipContent"></span>
      </div>
    </div>
  </section>
  }

  <!-- Message Section: same showMessageBlock conditions/flags as the legacy block above, replacing the progress bar instead of the gauge -->
  @if (!displayWidgetLoader && showMessageBlock) {
  <div class="flex items-center justify-center w-full min-h-[19px] text-sm text-neptune-default text-center" id="sp-overview-message-block">
    @if (multipleContractsSelected && widgetType !== 'all') {
    <p>{{ multipleHierarchiesSelectedMessage }}</p>
    }
    @if (noSalesData) {
    <p>No Sales Data</p>
    }
    @if (noRebatesNorProductLists) {
    <p>No Rebate or Products Lists entered</p>
    }
    @if (noProductList) {
    <p>No Product Lists entered</p>
    }
    @if (noDataAvailable) {
    <p>No Data Available</p>
    }
    @if (!eligibleForRebate) {
    <p>No Agreements</p>
    }
    @if (!multipleContractsSelected && multipleRebatesExistForContract && widgetType === 'rebate') {
    <p>Rebate information is not shown because multiple rebates are associated with this item. Please contact the Finance team for details.</p>
    }
  </div>
  }
</ng-container>
}
